import { AssignmentTypeTagSmall } from "components/AssignmentTypeTag";
import { ActivityType } from "enums/ActivityType.enum";
import { cn } from "helpers/classNames";
import { Uppdrag } from "types/uppdrag.type";

type Props = {
  uppdrag: Uppdrag;
  className?: string;
};

export const UppdragTypeList = ({ uppdrag, className }: Props) => {
  const fiveYearsCount = uppdrag.fiveYearsInspectionList.length;
  const sixMonthsCount = uppdrag.sixMonthsInspectionList.length;
  const wasteCount = uppdrag.wasteList.length;
  const waterMeasurementProtocolCount =
    uppdrag.waterMeasurementProtocolList.length;
  return (
    <span className={cn("flex items-center space-x-1", className)}>
      {fiveYearsCount > 0 && (
        <AssignmentTypeTagSmall
          type={ActivityType.FiveYearInspection}
          count={fiveYearsCount}
        />
      )}
      {sixMonthsCount > 0 && (
        <AssignmentTypeTagSmall
          type={ActivityType.SixMonthsInspection}
          count={sixMonthsCount}
        />
      )}
      {wasteCount > 0 && (
        <AssignmentTypeTagSmall
          type={ActivityType.Tomning}
          count={wasteCount}
        />
      )}
      {waterMeasurementProtocolCount > 0 && (
        <AssignmentTypeTagSmall
          type={ActivityType.WaterMeasurementProtocol}
          count={waterMeasurementProtocolCount}
        />
      )}
    </span>
  );
};
